import { classNames } from 'primereact/utils';
import { ButtonPassThroughOptions } from 'primereact/button';

export const PTButton: ButtonPassThroughOptions = {
  root: ({ props, context }: any) => ({
    className: classNames(
      'ax-btn gap-2',
      'transition duration-200 ease-in-out',
      {
        'ax-btn--primary':
          !props.link &&
          props.severity === null &&
          !props.text &&
          !props.outlined &&
          !props.plain,
        'ax-btn--link': props.link,
      },
      {
        'ax-btn--secondary':
          props.severity === 'secondary' &&
          !props.text &&
          !props.outlined &&
          !props.plain,
        'ax-btn--success':
          props.severity === 'success' &&
          !props.text &&
          !props.outlined &&
          !props.plain,
        'ax-btn--info':
          props.severity === 'info' &&
          !props.text &&
          !props.outlined &&
          !props.plain,
        'ax-btn--warning':
          props.severity === 'warning' &&
          !props.text &&
          !props.outlined &&
          !props.plain,
        'ax-btn--help':
          props.severity === 'help' &&
          !props.text &&
          !props.outlined &&
          !props.plain,
        'ax-btn--danger':
          props.severity === 'danger' &&
          !props.text &&
          !props.outlined &&
          !props.plain,
        'ax-btn--contrast':
          props.severity === 'contrast' &&
          !props.text &&
          !props.outlined &&
          !props.plain,
      },
      {
        'ax-btn--outlined': props.outlined,
        'ax-btn--outlined-primary':
          props.outlined && props.severity === null && !props.plain,
        'ax-btn--outlined-secondary':
          props.outlined && props.severity === 'secondary' && !props.plain,
        'ax-btn--outlined-success':
          props.outlined && props.severity === 'success' && !props.plain,
        'ax-btn--outlined-info':
          props.outlined && props.severity === 'info' && !props.plain,
        'ax-btn--outlined-warning':
          props.outlined && props.severity === 'warning' && !props.plain,
        'ax-btn--outlined-help':
          props.outlined && props.severity === 'help' && !props.plain,
        'ax-btn--outlined-danger':
          props.outlined && props.severity === 'danger' && !props.plain,
      },
      {
        'ax-btn--sm': props.size === 'small',
        'ax-btn--lg': props.size === 'large',
      },
      { 'flex-col': props.iconPos === 'top' || props.iconPos === 'bottom' },
      {
        'ax-btn--loading': context.loading,
        'ax-btn--disabled': context.disabled,
      },
      {
        'gap-2': props.icon,
      },
    ),
  }),
  label: ({ props }: any) => ({
    className: classNames(
      'ax-btn__label',
      {
        'hover:underline': props.link,
      },
      { 'invisible w-0': props.label == null },
    ),
  }),
  loadingIcon: ({ props }: any) => ({
    className: classNames('animate-spin mr-1', {
      'mr-2': props.loading && props.iconPos === 'left' && props.label != null,
      'ml-2 order-1':
        props.loading && props.iconPos === 'right' && props.label != null,
      'mb-2': props.loading && props.iconPos === 'top' && props.label != null,
      'mt-2 order-2':
        props.loading && props.iconPos === 'bottom' && props.label != null,
    }),
  }),
  badge: ({ props }: any) => ({
    className: classNames({
      'ml-2 w-4 h-4 leading-none flex items-center justify-center': props.badge,
    }),
  }),
};
